import React from 'react';

const clamp = (value, min, max) => {
    if (typeof value !== 'number' || Number.isNaN(value)) return min ?? 0;
    if (typeof min === 'number' && value < min) return min;
    if (typeof max === 'number' && value > max) return max;
    return value;
};

const parseNumberInput = (raw) => {
    if (raw === '' || raw === null || typeof raw === 'undefined') return null;
    const n = Number.parseInt(String(raw), 10);
    return Number.isNaN(n) ? null : n;
};

const QuantityStepper = ({
    value,
    onChange,
    min = 0,
    max,
    step = 1,
    disabled = false,
    disabledDecrement,
    disabledIncrement,
    inputAriaLabel = 'Quantity',
    decrementAriaLabel = 'Decrease quantity',
    incrementAriaLabel = 'Increase quantity',
    minusIcon = '−',
    plusIcon = '+',
    className = '',
    style,
    inputProps,
    buttonSize = 48,
    inputWidth = 56,
    iconSize = 16,
}) => {
    const safeValue = typeof value === 'number' ? value : (value ?? 0);
    const decDisabled = disabled || (typeof disabledDecrement === 'boolean' ? disabledDecrement : safeValue <= min);
    const incDisabled = disabled || (typeof disabledIncrement === 'boolean' ? disabledIncrement : false);
    const borderColor = 'rgba(0,0,0,.2)';

    const commit = (next) => {
        const clamped = clamp(next, min, max);
        onChange?.(clamped);
    };

    const inputClassName = ['form-control', 'britge-qty-stepper__input', 'text-center', inputProps?.className].filter(Boolean).join(' ');

    return (
        <div
            className={`britge-qty-stepper ${className}`}
            style={{
                display: 'inline-flex',
                alignItems: 'stretch',
                border: '1px solid rgba(0,0,0,.2)',
                borderRadius: '999px',
                overflow: 'hidden',
                background: '#fff',
                ...style,
            }}
        >
            <button
                type="button"
                className="btn britge-qty-stepper__btn"
                aria-label={decrementAriaLabel}
                disabled={decDisabled}
                onClick={() => commit((safeValue || 0) - step)}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: `0 0 ${buttonSize}px`,
                    minWidth: buttonSize,
                    minHeight: buttonSize,
                    padding: 0,
                    border: 0,
                    borderRight: `1px solid ${borderColor}`,
                    borderRadius: 0,
                    backgroundColor: 'transparent',
                    color: 'inherit',
                    boxShadow: 'none',
                    opacity: decDisabled ? 0.55 : 1,
                }}
            >
                <span
                    className="britge-qty-stepper__icon"
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: iconSize,
                        height: iconSize,
                        lineHeight: 1,
                    }}
                >
                    {minusIcon}
                </span>
            </button>
            <input
                type="number"
                inputMode="numeric"
                min={min}
                {...inputProps}
                className={inputClassName}
                aria-label={inputAriaLabel}
                value={safeValue || 0}
                disabled={disabled}
                style={{
                    width: inputWidth,
                    minWidth: inputWidth,
                    border: 0,
                    borderRadius: 0,
                    boxShadow: 'none',
                    backgroundColor: 'transparent',
                    paddingLeft: 6,
                    paddingRight: 6,
                }}
                onChange={(e) => {
                    const parsed = parseNumberInput(e.target.value);
                    if (parsed === null) return commit(min ?? 0);
                    commit(parsed);
                }}
            />
            <button
                type="button"
                className="btn britge-qty-stepper__btn"
                aria-label={incrementAriaLabel}
                disabled={incDisabled}
                onClick={() => commit((safeValue || 0) + step)}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: `0 0 ${buttonSize}px`,
                    minWidth: buttonSize,
                    minHeight: buttonSize,
                    padding: 0,
                    border: 0,
                    borderLeft: `1px solid ${borderColor}`,
                    borderRadius: 0,
                    backgroundColor: 'transparent',
                    color: 'inherit',
                    boxShadow: 'none',
                    opacity: incDisabled ? 0.55 : 1,
                }}
            >
                <span
                    className="britge-qty-stepper__icon"
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: iconSize,
                        height: iconSize,
                        lineHeight: 1,
                    }}
                >
                    {plusIcon}
                </span>
            </button>
        </div>
    );
};

export default QuantityStepper;



